<template>
  <div class="card-socials">
    <div
      class="card-socials__background-overlay"
    />
    <div class="card-socials__content">
      <div class="card-socials__title-block">
        <span class="card-socials__title h3">Хотите увидеть то,<br/> что не попадает на сайт? </span>
        <div class="card-socials__items-list">
          <div
            v-for="(item, index) in itemsList"
            :key="`card-socials-title-block-items-list-item-${index}`"
            class="card-socials__item"
          >
            <div
              v-if="index !== 0"
              class="card-socials__item-separator"
            >
              <img
                src="~/assets/img/svg/common/rhombus.svg"
              />
            </div>
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="card-socials__inner-vertical-card">
        <innerVerticalSocials />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import innerVerticalSocials from '~/components/catalog/card-socials/InnerVerticalSocials.vue'
const itemsList = computed(() => {
  return [
    'Лайфхаки',
    'Новинки',
    'Готовые детские',
    'Идеи',
    'Вдохновение',
    'Вопросы и ответы'
  ]
})
</script>

<style scoped lang="scss">
.card-socials {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 29px 0 30px;
}
.card-socials__background-overlay {
  width: 100%;
  height: calc(100% - 30px);
  position: absolute;
  top: 15px;
  left: 0;
  background-color: #D3E6C6;
  border-radius: 20px;
}
.card-socials__content {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  height: 100%;
}
.card-socials__inner-vertical-card {
  height: 100%;
  width: calc(100% / 2);
}
.card-socials__title-block {
  padding-bottom: 46px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 330px;
  font-weight: 600;
}
.card-socials__title {
  font-weight: 600;
  color: var(--text-color-text);
}
.card-socials__items-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.card-socials__item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
}
@media screen and (max-width: 1359px) {
  .card-socials {
    padding-top: 32px;
  }
  .card-socials__background-overlay {
    top: 0;
    height: 86%;
  }
  .card-socials__content {
    flex-direction: column;
    gap: 30px;
    justify-content: space-between;
  }
  .card-socials__inner-vertical-card {
    width: 100%;
  }
  .card-socials__title-block {
    padding-bottom: 0;
    max-width: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .card-socials__title {
    text-align: center;
  }
  .card-socials__items-list {
    justify-content: center;
    align-items: center;
    max-width: 400px;
  }
  .card-socials__item {
    //justify-content: space-between;
  }
}
@media screen and (max-width: 859px) {
  .card-socials {
    padding: 32px 17px 0;
  }
  .card-socials__title-block {
    align-items: center;
  }
  .card-socials__title {
    text-align: center;
  }
  .card-socials__items-list {
    justify-content: center;
  }
  .card-socials__item-separator {
    width: 5px;
    height: 5px;
  }
}
</style>
